module.exports = __webpack_public_path__ + "static/media/team-amanda.879ff942.jpg";